import { React, PT, withRouter, connect, fetchApi } from '@gasbuddy/react';
import { Segment, Input, Button, Dimmer, Loader, Message, Table } from 'semantic-ui-react';
import moment from 'moment';
import { Auth, Nav } from '../../components';
import { Role } from '../../roles';

class InstrumentSearch extends React.Component {
  state = {};

  setStateField(field) {
    return (_, { value }) => {
      const stateChange = { [field]: value };
      this.setState(stateChange);
    };
  }

  callApi = () => {
    const { digits, name } = this.state;
    this.setState({ loading: true }, async () => {
      const { body, status, error } = await fetchApi({
        url: '/payments/instruments/search',
        catchErrors: true,
        body: { digits, name },
      });
      if (error || status !== 200) {
        this.setState({ error: body || error, loading: false });
      } else {
        this.setState({ instruments: body.instruments, loading: false });
      }
    });
  }

  render() {
    const { digits, name, loading, instruments, error } = this.state;
    const { history } = this.props;

    return (
      <Auth forRoles={[Role.Superuser, Role.PaymentView]}>
        <Nav>
          <div>
            {error && (
              <Message error>
                Unable to run the search.
                <pre>{JSON.stringify(error, null, '\t')}</pre>
              </Message>
            )}
            <Segment>
              <div>
                <span style={{ marginRight: 10 }}>Find bank accounts ending in</span>
                <Input
                  onChange={this.setStateField('digits')}
                  defaultValue={digits}
                />
                <span style={{ marginLeft: 10, marginRight: 10 }}>with bank name that includes</span>
                <Input
                  onChange={this.setStateField('name')}
                  defaultValue={name}
                />
              </div>
              <div style={{ textAlign: 'right', marginTop: 5 }}>
                <Button primary onClick={this.callApi}>Search</Button>
              </div>
            </Segment>
            <Dimmer.Dimmable dimmed={loading}>
              <Dimmer active={loading}>
                <Loader />
              </Dimmer>
              <Table basic="very" selectable style={{ tableLayout: 'fixed', fontSize: '0.9em' }}>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Account Id</Table.HeaderCell>
                    <Table.HeaderCell>Provider</Table.HeaderCell>
                    <Table.HeaderCell>Created</Table.HeaderCell>
                    <Table.HeaderCell width={2}>Last Digits</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {(instruments || []).map(i => (
                    <Table.Row
                      warning={!!i.deleted}
                      className={i.deleted ? 'deleted' : null}
                      key={i.instrument_account_map_id}
                      onClick={() => history.push(`/payments/instrument-map/${i.instrument_account_map_id}`)}
                    >
                      <Table.Cell>{i.account_id}</Table.Cell>
                      <Table.Cell>{i.provider_name}</Table.Cell>
                      <Table.Cell>{moment(i.created).format('MM/DD/YY')}</Table.Cell>
                      <Table.Cell>{i.extra_data?.last_digits}</Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </Dimmer.Dimmable>
          </div>
        </Nav>
      </Auth>
    );
  }
}

InstrumentSearch.propTypes = {
  history: PT.shape({ push: PT.func.isRequired }).isRequired,
  match: PT.shape({
    params: PT.shape({ accountId: PT.string }),
  }).isRequired,
};

InstrumentSearch.defaultProps = {
};

export default withRouter(connect(({ users }) => ({ users }))(InstrumentSearch));
